module.exports = __webpack_public_path__ + "img/2000pigc.bc663c4a.png";